<template>
  <div>
    <div class="home-product">
      <div class="home-pro-title">
        <div class="pro-title-left">
          <svg-icon icon-class="home_pro_line"></svg-icon>
          <span>产品库</span>
        </div>
      </div>
      <div class="home-pro-img">
        <div class="img-sty img-zq">
          <van-tag color="#000000" text-color="#F80026">新产品13款</van-tag>
          证券
        </div>
        <div class="img-sty img-bx">
          <van-tag color="#000000" text-color="#F80026">新产品89款</van-tag>
          保险
        </div>
        <div class="img-sty img-jy">
          <van-tag color="#000000" text-color="#F80026">新产品34款</van-tag>
          教育
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast } from "vant";
export default {
  data() {
    return {
      productList: [
        // {value:[
        //     {img:require('./img/swipe1.png')}
        // ]}
      ],
      active: '1',
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="less" scoped>
.home-product {
  width: 375px;
  height: 125px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: #fff;
  overflow: hidden;
  font-family: Source Han Sans CN;
  .home-pro-title {
    width: 345px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pro-title-left {
    display: flex;
    align-items: center;
    .svg-icon {
      width: 2px;
      height: 13px;
    }
    span {
      padding-left: 14px;
      font-size: 15px;
      font-weight: Bold;
      font-family: "PingFang SC";
      color: #333333;
    }
  }
  
  .home-pro-img {
    width: 355px;
    margin: 11.5px auto 0 auto;
    display: flex;
    justify-content: space-between;
    .img-sty{
      width: 113px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      position: relative;
      font-size: 14px;
      color: #FFFFFF;
    }
    .img-zq{
      background: url('../../assets/publicImg/p-zq.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .img-bx{
      background: url('../../assets/publicImg/p-bx.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .img-jy{
      background: url('../../assets/publicImg/p-jy.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .van-tag{
      position: absolute;
      top: 0;
      right: 0;
     font-size: 8px;
    }
  }
}
</style>